import type { Size } from '@view-model/models/common/basic';
import { Point } from '@view-model/models/common/basic';
import { CommentConstants } from '../constants';

/*
 * コメントの位置（position）、コメントボタンのサイズ(menuButtonSize)、コメントメニューのサイズ(popupMenuSize)から、
 * コメントメニューボタン・コメントメニューポップアップの表示位置座標を取得するためのクラスです
 */
export class CommentMenuPositionMap {
  private readonly width: number;

  constructor(
    private readonly position: Point,
    private readonly menuButtonSize: Size,
    private readonly popupMenuSize: Size,
    width?: number
  ) {
    this.width = width ?? CommentConstants.UISetting.width;
  }

  /**
   * コメントメニューボタンの表示位置左上座標を返します
   */
  getMenuButtonPosition(): Point {
    // 右寄せにするために、自身の幅を引いている
    const x = this.width - this.menuButtonSize.width;

    return Point.fromPosition({ x: x, y: this.position.y });
  }

  /**
   * コメントメニューポップアップの表示位置の左上座標を返します
   */
  getPopupMenuPosition(): Point {
    // 右寄せにするために、自身の幅を引いている
    const x = this.width - this.popupMenuSize.width;

    // ボタンの高さ分位置をずらしている
    const y = this.position.y + this.menuButtonSize.height;

    return Point.fromPosition({ x: x, y: y });
  }

  /**
   * コメントメニューポップアップをボタンの右横に表示する場合の左上座標を返します
   */
  getNewPopupMenuPosition(): Point {
    // ボタンの右端（= width）をポップアップの左端とする
    const x = this.width;

    // ボタンと同じ高さに揃える
    const y = this.position.y;

    return Point.fromPosition({ x: x, y: y });
  }
}
